import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["content", "img", "videoSrc", "linkCallback"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Markdown, Modal, useTheme } from '@Sage/hoi-poi-ui';
import styles from "./styles/AddOnInfo";
const useStyles = createUseStyles(styles, 'AddOnInfo');
const AddOnInfo = /*#__PURE__*/memo(_ref => {
  let {
      content,
      img,
      videoSrc,
      linkCallback
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const theme = useTheme();
  const modalProps = useMemo(() => {
    return _objectSpread({
      size: 'large',
      autoHeight: false
    }, props);
  }, [props]);
  const renderContent = useMemo(() => {
    const contentProps = {
      className: classes.content,
      content,
      linkCallback,
      overrides: {
        a: {
          target: '_blank'
        },
        p: {
          color: theme.colors.textLight.secondary
        },
        ul: {
          overrides: {
            listItem: {
              style: {
                margin: 0
              }
            },
            Text: {
              color: theme.colors.textLight.secondary
            }
          }
        }
      }
    };
    return /*#__PURE__*/React.createElement(Markdown, contentProps);
  }, [classes.content, content, linkCallback, theme]);
  const iframeProps = useMemo(() => ({
    src: videoSrc,
    allowFullScreen: true
  }), [videoSrc]);
  const renderPic = useMemo(() => {
    switch (true) {
      case !!videoSrc:
        return /*#__PURE__*/React.createElement("iframe", _extends({
          title: "vimeo-player"
        }, iframeProps));
      case !!img:
        return /*#__PURE__*/React.createElement("img", {
          src: img.src,
          alt: img.alt || ''
        });
      default:
        return null;
    }
  }, [iframeProps, img, videoSrc]);
  return /*#__PURE__*/React.createElement(Modal, modalProps, /*#__PURE__*/React.createElement("div", {
    className: classes.main
  }, renderContent && /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, renderContent), renderPic && /*#__PURE__*/React.createElement("div", {
    className: classes.pic
  }, renderPic)));
});
process.env.NODE_ENV !== "production" ? AddOnInfo.propTypes = {
  content: PropTypes.string,
  img: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  videoSrc: PropTypes.string,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  middleButtonText: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  onMiddleButton: PropTypes.func,
  linkCallback: PropTypes.func
} : void 0;
export default AddOnInfo;